import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getStyles } from './getStyles';

export const RadialProgressUnthemed = (props) => {
  const {
    progressPercentage,
    size,
    stroke,
    strokeWidth,
    classes,
    className,
  } = props;

  const radius = (size / 2) - (strokeWidth / 2);
  const strokeLength = Math.PI * 2 * radius;
  const sizePixels = `${size}px`;

  return (
    <div
      className={classnames('radial-progress', classes.container, className)}
      style={{
        width: sizePixels,
        height: sizePixels,
      }}
    >
      <svg
        className={classes.svg}
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
      >
        <circle
          className={classes.circle}
          cx={`${size / 2}`}
          cy={`${size / 2}`}
          r={`${radius}`}
          style={{
            strokeWidth,
          }}
        />
        <circle
          className={classnames(classes.circle, classes.primary)}
          cx={`${size / 2}`}
          cy={`${size / 2}`}
          r={`${radius}`}
          style={{
            stroke,
            strokeWidth,
            strokeDasharray: `${progressPercentage * strokeLength} ${strokeLength}`,
          }}
        />
      </svg>
      <div
        className={classnames('radial-progress-text', classes.text)}
        style={{
          width: sizePixels,
          height: sizePixels,
          lineHeight: sizePixels,
        }}
      >
        {`${parseInt(progressPercentage * 100, 10)}%`}
      </div>
    </div>
  );
};

RadialProgressUnthemed.propTypes = {
  progressPercentage: PropTypes.number.isRequired,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
  stroke: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.shape({}).isRequired,
};

RadialProgressUnthemed.defaultProps = {
  size: 128,
  stroke: '#107C10',
  strokeWidth: 14,
  className: null,
};

export const RadialProgress = withDefaultStyles(RadialProgressUnthemed, getStyles);
